import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/form.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/error.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/footers/Copyright.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/CategoriesMenu.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/HeaderAccountSelector.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderCart.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/HeaderCartShow.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderSearch.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderWishlist.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/Logo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/MobileMenuWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/main/ForgotPasswordMain.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/wrappers/ClientProviders.js");
